import JSZip from "jszip";

const mimeTypes: Record<string, string> = {
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  mp4: "video/mp4",
};

export const extractMediaFromPptx = async (
  pptxFile: Blob | ArrayBuffer,
): Promise<{ name: string; blob: Blob }[]> => {
  const zip = await JSZip.loadAsync(pptxFile);
  const mediaFiles: { name: string; blob: Blob }[] = [];

  const mediaFolder = "ppt/media/";

  const promises: Promise<void>[] = [];

  for (const fileName of Object.keys(zip.files)) {
    if (fileName.startsWith(mediaFolder)) {
      const file = zip.files[fileName];
      if (!file.dir) {
        promises.push(
          new Promise(async (resolve, reject) => {
            try {
              const fileExt = fileName.split(".").pop()?.toLowerCase() || "";
              const mimeType = mimeTypes[fileExt] || "application/octet-stream";
              const content = await file.async("blob");
              const typedBlob = new Blob([content], { type: mimeType });
              const { width, height } =
                await getHeightAndWidthFromFile(typedBlob);

              if (width > 30 && height > 30) {
                mediaFiles.push({
                  name: fileName.split("/").pop() || fileName,
                  blob: typedBlob,
                });
              }
              resolve();
            } catch (e) {
              console.log(e);
              reject(e);
            }
          }),
        );
      }
    }
  }

  await Promise.allSettled(promises);

  return mediaFiles;
};

const getHeightAndWidthFromFile = (file: Blob) => {
  return new Promise<{ width: number; height: number }>((resolve) => {
    const fr = new FileReader();
    fr.onload = () => {
      const img = new Image();
      img.onload = () => {
        resolve({
          height: img.height,
          width: img.width,
        });
      };
      img.src = fr.result as string;
    };
    fr.onerror = () => {
      resolve({ width: 0, height: 0 });
    };
    fr.readAsDataURL(file);
  });
};
